import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const getToken = () => localStorage.getItem("access_token");
export const setTokens = ({ access_token, refresh_token }) => {
  if (access_token) localStorage.setItem("access_token", access_token);
  if (refresh_token) localStorage.setItem("refresh_token", refresh_token);
};
export const clearTokens = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
};

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    if (status === 401 && !original._retried && !original.url.includes("/auth/login") && !original.url.includes("/auth/refresh")) {
      original._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh", { refresh_token: localStorage.getItem("refresh_token") });
        const { data } = await refreshing;
        refreshing = null;
        setTokens(data);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        refreshing = null;
        clearTokens();
      }
    }
    return Promise.reject(error);
  }
);

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export default api;
